export const navigationItems = [
    {
        id: 'about-credit-cards',
        name: 'About credit cards',
        href: '#about-credit-cards',
    },
    {
        id: 'types-of-card',
        name: 'Types of card',
        href: '#types-of-card',
    },
    {
        id: 'pros-and-cons',
        name: 'Pros and cons',
        href: '#pros-and-cons',
    },
    {
        id: 'find-the-right-card',
        name: 'Find the right card',
        href: '#find-the-right-card',
    },
    {
        id: 'why-totallymoney',
        name: 'Why TotallyMoney?',
        href: '#why-totallymoney',
    },
    {
        id: 'faqs',
        name: 'FAQs',
        href: '#faqs',
    },
]
